// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-608c1b72] .el-divider--horizontal{margin:20px 0!important}[data-v-608c1b72] .el-divider__text.is-left{left:0}[data-v-608c1b72] .el-divider__text{padding:0 10px 0 0}", ""]);
// Exports
module.exports = exports;
